import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import {useDelayToNextFrame} from '@adv-mt/mt-hook-use-delay-to-next-frame'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {BASE_CLASS} from './config.js'
import YoutubeIframe from './media-video-youtube-iframe.js'

const PLACEHOLDER_CLASS = `${BASE_CLASS}-placeholder`
const PLACEHOLDER_PLAY_CLASS = `${PLACEHOLDER_CLASS}Play`

const getVideoThumbnailSrc = id => `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`

const getAutoPlayUrl = url => {
  const youtubeUrl = new URL(url)
  const params = new URLSearchParams(youtubeUrl)
  params.append('autoplay', 1)
  youtubeUrl.search = params.toString()
  return youtubeUrl.toString()
}

const YoutubePlaceholder = ({isPlayable, onClickPlaceholder, placeholderImageSrc, videoId, videoURL, title}) => {
  const {domain} = useContext(Context)
  const {track} = useAnalyticsTrack()
  const delayToNextFrame = useDelayToNextFrame()

  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')
  const {TRACKING_EVENT_NAMES} = config.get('tracking')

  const playButtonSrc = `${URL_STATICS_IMAGES}youtube-play.svg`
  const [isLoaded, setIsLoaded] = useState(false)
  const [autoPlayUrl, setAutoPlayUrl] = useState()

  const videoThumbnailSrc = placeholderImageSrc || getVideoThumbnailSrc(videoId)

  const handleClickPlay = async () => {
    if (!isPlayable) return
    setIsLoaded(true)

    if (onClickPlaceholder) {
      onClickPlaceholder()
      return
    }

    delayToNextFrame(async () => {
      const trackingData = await domain.get('get_event_tracking_data_use_case').execute({
        event: TRACKING_EVENT_NAMES.NEWS_VIDEO_PLAYED
      })
      track(trackingData)
    })
  }

  useMount(() => {
    const url = getAutoPlayUrl(videoURL)
    setAutoPlayUrl(url)
  })

  return isLoaded ? (
    <YoutubeIframe videoURL={autoPlayUrl} title={title} />
  ) : (
    <div className={PLACEHOLDER_CLASS} onClick={handleClickPlay} data-testid="video-placeholder">
      <AtomImage src={videoThumbnailSrc} />
      <div className={PLACEHOLDER_PLAY_CLASS}>
        <AtomImage src={playButtonSrc} />
      </div>
    </div>
  )
}

export default YoutubePlaceholder

YoutubePlaceholder.propTypes = {
  isPlayable: PropTypes.bool,
  onClickPlaceholder: PropTypes.func,
  placeholderImageSrc: PropTypes.string,
  videoId: PropTypes.string,
  videoURL: PropTypes.string,
  title: PropTypes.string
}
